import {
  FieldMappingSelectField,
  FieldMappingSelectFieldProps,
} from '@components/field-mapping-select-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFieldMappingSelectFieldProps<T = unknown> = FormFieldProps<
  FieldMappingSelectFieldProps,
  T
>;

export function FormFieldMappingSelectField<T>(props: FormFieldMappingSelectFieldProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'field-mapping' });

  return <FieldMappingSelectField {...props} {...formFieldProps} />;
}
